const frequencyOptions = [
    "Nunca",
    "Casi nunca",
    "Algunas veces",
    "Bastantes veces",
    "Casi siempre",
    "Siempre",
  ];
  
  export default frequencyOptions;
  